module.exports = __webpack_public_path__ + "static/labs-cd8e269e64ac2aabb3ad12a7e46df41c.jpg";